<template>
  <v-form class="mt-13">

    <v-tabs show-arrows background-color="#0D47A1" icons-and-text dark grow>
      <v-tabs-slider color="#0D47A1 "></v-tabs-slider>
      <v-tab>
        <v-btn text x-large
          ><v-icon left> mdi-page-next</v-icon>Task detail:
          <h5>{{ datos[0].nombreTarea }}</h5></v-btn
        >
      </v-tab>
      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-form ref="loginForm" lazy-validation>
              <v-card-text>
                <v-row dense>
                  <v-col
                    class="text-lg-right"
                    
                    cols="12"
                    md="12"
                    sm="12"
                  >
               
                  
                    <h3>ACTIONS TASK</h3>
                    <v-icon
                      x-large
                      v-if="datos[0].estatus != 'In progress'"
                      color="orange"
                      class="mr-2"
                      @click="TareaEnProceso(datos[0].idTarea, datos[0].fechaInicio)"
                    >
                      mdi-clock
                    </v-icon>

                    <v-icon
                      x-large
                      class="mr-2"
                      color="green"
                      v-if="datos[0].estatus != 'Finished'"
                      @click="TerminarTarea(datos[0].idTarea)"
                    >
                      mdi-calendar-check
                    </v-icon>

                    <v-icon
                      x-large
                      color="red"
                      class="mr-2"
                      v-if="datos[0].estatus != 'Canceled'"
                      @click="CancelarTarea(datos[0].idTarea)"
                    >
                      mdi-calendar-remove
                    </v-icon>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      label="Manager"
                      outlined
                      readonly
                      v-model="participanteChat"
                    ></v-text-field>
                    <v-text-field
                      label="Create on"
                      outlined
                      readonly
                      v-model="datos[0].fechaCreacion"
                    ></v-text-field>

                    <v-text-field
                      label="Start date"
                      outlined
                      readonly
                      v-model="datos[0].fechaInicio"
                    ></v-text-field>

                    <v-text-field
                      label="Finished on"
                      outlined
                      readonly
                      required
                      v-model="datos[0].fechaFin"
                    ></v-text-field>

                    <v-textarea
                      outlined
                      name="input-7-4"
                      label="description"
                      :value="datos[0].descripcion"
                      readonly
                    ></v-textarea>
                  </v-col>

                  <v-col cols="9">
                    <v-container>
                      <h3>CHAT</h3>

                      <Chat v-if="estatusChat" :datos="datos[0]" />

                      <Encargados
                        v-if="encargados"
                        @cerrar="CerrarSelect"
                        :datos="datos[0]"
                        :estatus="estatusSelect"
                      />

                      <Archivos
                        v-if="estatusArchivo"
                        :nodo="datos[0].idTarea"
                        @cerrar="CerrarArchivos"
                        :estatus="estatusArchivos"
                      />

                      <input
                        type="file"
                        ref="boton"
                        class="d-done"
                        @change="BuscarImagen($event)"
                      />
                    </v-container>

                    <v-btn
                      color="#EF6C00"
                      class="mb-5 ml-5"
                      @click="(estatusArchivo = true), (estatusArchivos = true)"
                      large
                      dark
                    >
                      <v-icon x-large color="white"> mdi-file </v-icon>
                    </v-btn>

                    <v-btn
                      color="#EF6C00"
                      class="mb-5 ml-5"
                      @click="confirmacion = true"
                      large
                      dark
                      v-if="rol == 1"
                    >
                      <v-icon x-large color="white"> mdi-delete </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row dense>
                  <v-col cols="6" sm="1">
                    
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <v-dialog v-model="confirmacion" persistent max-width="25%">
      <v-tabs show-arrows background-color="#0D47A1" icons-and-text dark grow>
        <v-tabs-slider color="#0D47A1 "></v-tabs-slider>
        <v-tab>
          <v-icon right>mdi-delete</v-icon>
        </v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-form lazy-validation>
                <v-row>
                  <v-card-text>
                    <v-row cols="12" sm="3" md="6">
                      <v-col
                        ><h3>
                          Are you sure you want to delete this task?
                        </h3></v-col
                      >
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      large
                      color="#EF6C00"
                      @click="confirmacion = false"
                      dark
                    >
                      Cancel
                    </v-btn>

                    <v-btn
                      color="#EF6C00"
                      large
                      dark
                      @click="EliminarTarea(), (estatusChat = false)"
                    >
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

  </v-form>
    
</template>

<script>
import Chat from "../components/chat";
import Encargados from "../components/Encargados";
import { firebase, storage, db } from "../firebase";
import Archivos from "../components/Archivos";

export default {
  components: {
    Chat,
    Encargados,
    Archivos,
  },
  data: () => ({
    idTarea:'',
    rol: sessionStorage.getItem("rol"),
    participanteChat: "",
    file: null,
    urlTemporal: "",
    encargados: false,
    estatusChat: true,
    rol: sessionStorage.getItem("rol"),
    estatusSelect: false,
    estatusArchivo: false,
    confirmacion: false,
    datos:[],
  
  }),
  mounted() {
    this.ConsultarDatosTarea();
    this.ConsultarEmpleadosXTarea();
  },
  methods: {
    ConsultarDatosTarea(){
       let parametros = new URLSearchParams();
       this.idTarea = this.$route.params.id;
       console.log("funciona? "+this.idTarea);
      parametros.append("accion", 20);
      parametros.append("idTarea", this.idTarea);

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
        data: parametros,
      })
        .then(
          function (response) {
            console.log(response.data);
            response.data.forEach((element)=>{
              this.datos.push(element);
            });

            console.log(datos);
            
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log(response);
          }.bind(this)
        );

    },
    ConsultarColaboradores() {
      let parametros = new URLSearchParams();

      parametros.append("accion", 6);
      parametros.append("idTarea", idTarea);

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
        data: parametros,
      })
        .then(
          function (response) {
            alert("Tarea cancelada");
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log(response);
          }.bind(this)
        );
    },
    EnviarURL(url, name) {
      var nombre = sessionStorage.getItem("nombre");
      var urk = url;
      var mensaje = name;
      db.collection(this.datos[0].idTarea)
        .add({
          //Nodo padre del que queremos sacar los nodos hijos
          name: nombre,
          message: mensaje,
          url: url,
          download: true,
          time: Date.now(),
        })
        .catch((error) => {
          console.log(error);
        }); //promesa para el error
      this.ConsultarColaboradores();
    },
    ConsultarColaboradores() {
      let parametros = new URLSearchParams();
      parametros.append("accion", 18);
      parametros.append("idTarea", this.datos[0].idTarea);
      parametros.append("idEmpleado", sessionStorage.getItem("uid"));

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
        data: parametros,
      })
        .then(
          function (response) {
            response.data.forEach((element) => {
              console.log(element);
              this.Enviarnoty(element.idEmpleado);
            });
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log("Error" + response);
          }.bind(this)
        );
    },
    Enviarnoty(uid) {
      var nombre = "";
      db.collection("noty" + uid)
        .add({
          //Nodo padre del que queremos sacar los nodos hijos
          name: nombre,
          type: "1",
          message: "New message:  " + this.datos[0].nombreTarea,
          time: Date.now(),
          idTarea: this.datos[0].idTarea,
          estatus: true,
        })
        .catch((error) => {
          console.log(error);
        }); //promesa para el error
    },
    async SubirImagen() {
      try {
        const refImagen = storage
          .ref()
          .child("Archivos" + this.datos[0].idTarea)
          .child(this.file.name);

        const res = await refImagen.put(this.file);

        const urlDescarga = await refImagen.getDownloadURL();

        console.log(urlDescarga);
        this.EnviarURL(urlDescarga, this.file.name);
      } catch (error) {
        console.log(error);
      }
    },
    BuscarImagen(event) {
      this.file = event.target.files[0];
      this.SubirImagen();
    },
    CerrarSelect() {
      this.encargados = false;
    },
    TerminarTarea(idTarea) {
      let parametros = new URLSearchParams();

      parametros.append("accion", 5);
      parametros.append("idTarea", idTarea);

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
        data: parametros,
      })
        .then(
          function (response) {
            alert("Finished");
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log(response);
          }.bind(this)
        );
    },
    CancelarTarea(idTarea) {
      let parametros = new URLSearchParams();

      parametros.append("accion", 6);
      parametros.append("idTarea", idTarea);

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
        data: parametros,
      })
        .then(
          function (response) {
            alert("Canceled");
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log(response);
          }.bind(this)
        );
    },
    TareaEnProceso(idTarea, fechaInicio) {
      if (fechaInicio == "0000-00-00") {
        this.dialogCalendar = true;
      } else {
        let parametros = new URLSearchParams();

        parametros.append("accion", 7);
        parametros.append("idTarea", idTarea);

        axios({
          method: "post",
          url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
          data: parametros,
        })
          .then(
            function (response) {
              alert("In process");
            }.bind(this)
          )
          .catch(
            function (response) {
              //handle error
              console.log(response);
            }.bind(this)
          );
      }
    },
    AccionCerrar() {
      this.$emit("cerrar");
    },
    async subirImagen() {
      try {
        const refImagen = storage.ref().child("Archivos" + datos[0].idTarea);

        const res = await refImagen.put(file);
      } catch (error) {
        conole.log(error);
      }
    },
    CerrarArchivos() {
      this.estatusArchivo = false;
    },
    LimpiarNotificaciones() {
      var nombre = sessionStorage.getItem("uid");
      let ref = db.collection("noty" + nombre).doc("");

      ref
        .update({
          notificacion: false,
        })
        .then(function () {
          this.AccionMenu(item.type);
          //this.Notificar();
          //console.log("Document successfully deleted!");
        })
        .catch(function (error) {
          console.error("Error al aceptar notificación: ", error);
        });
    },
    EliminarTarea() {
      let parametros = new URLSearchParams();
      parametros.append("accion", 8);
      parametros.append("idTarea", this.datos[0].idTarea);

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorTareas.php",
        data: parametros,
      })
        .then(
          function (response) {
            console.log(response);
            this.AccionCerrar();
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log(response);
          }.bind(this)
        );
    },
    EventoCerrarESC() {
      alert("evento esc");
    },
    ConsultarEmpleadosXTarea() {
      let parametros = new URLSearchParams();
      parametros.append("accion", 7);
      parametros.append("idTarea", this.datos[0].idTarea);
      parametros.append("idEmpleado", sessionStorage.getItem("uid"));

      axios({
        method: "post",
        url: sessionStorage.getItem("ruta") + "/core/ControladorEmpleados.php",
        data: parametros,
      })
        .then(
          function (response) {
            console.log(response.data[0].idEmpleado);
            this.participanteChat = response.data[0].nombre;
          }.bind(this)
        )
        .catch(
          function (response) {
            //handle error
            console.log(response);
          }.bind(this)
        );
    },
  },
};
</script>
